<template>
  <v-container fluid>
    <PageHeading
      text="Анкеты юр. лиц"
      mode="grid"
      :grid-data-loading="gridDataLoading"
      :results-count="resultsCount"
    >
    </PageHeading>
    <v-row>
      <v-col>
        <GridLegalDetails
          ref="grid"
        />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import PageHeading from '@/components/page-heading/PageHeading'
import gridPageInterfaceMixin from '@/interfaces/grid-page-interface-mixin'
import GridLegalDetails from '@/pages/legal-details/grid/GridLegalDetails'
export default {
  name: 'PageLegalDetails',
  metaInfo () {
    return {
      title: 'Анкеты юр. лиц'
    }
  },
  components: { GridLegalDetails, PageHeading },
  mixins: [gridPageInterfaceMixin]
}
</script>

<style scoped>

</style>
